import { StatusChip } from 'app/components';

export const StatusRow = ({ data, accessLabel }) => {
  const label = data?.[accessLabel];
  return <StatusChip label={label} type={label} />;
};
